import { render, staticRenderFns } from "./InternDeprecated.vue?vue&type=template&id=3e83a6c6&scoped=true"
import script from "./InternDeprecated.vue?vue&type=script&lang=js"
export * from "./InternDeprecated.vue?vue&type=script&lang=js"
import style0 from "./InternDeprecated.vue?vue&type=style&index=0&id=3e83a6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83a6c6",
  null
  
)

export default component.exports